import { type InternalViewProps } from './types';
import { RenderBlocksWithoutTitle } from './RenderBlocksWithoutTitle';
import {
  InternalLayout,
  InternalLayoutProvider,
} from 'volto-ministerio-publico-federal/components/Layouts';

const InternalView = ({ content }: InternalViewProps) => {
  const { title, description, relatedItems, largura_total, ocultar_titulo } =
    content || {};

  return (
    <InternalLayoutProvider
      title={title}
      description={description}
      relatedItems={relatedItems}
      larguraTotal={largura_total}
      ocultarTitulo={ocultar_titulo}
      reviewState={content?.review_state}
    >
      <InternalLayout>
        <RenderBlocksWithoutTitle content={content} />
      </InternalLayout>
    </InternalLayoutProvider>
  );
};

export default InternalView;
